import { Button, useTheme } from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";
import ModalBox from "../ModalBox";
import { useEmployees } from "../../view/employee/Provider";

const ButtonWrapper = styled.div`
  width: fit-content;
  margin: 10px auto;

  button {
    margin: 0 10px;
    color: white;
    font-size: 11px;
  }
`;
const HourlyRateActions = ({
  data,
  row,
  id,
  actions,
  editing,
  setEditing,
  roleId,
  setRoleId,
  inSiteDetails,
}) => {
  let theme = useTheme();
  const [open, setOpen] = useState(false);
  const [openDeletAllSites, setOpenDeleteAllSites] = useState(false);
  const {
    state: { selected: employee },
    fetchEmployeesSiteList,
    removeAllRoles,
  } = useEmployees();

  const handleClose = () => {
    setOpen(false);
  };
  const handleDelete = (id) => {
    editing && setEditing(false);
    !editing && setOpen(true);
  };

  const handleEdit = (row) => {
    editing &&
      actions.edit(
        data.filter((e) => e.id === id || e.roleId === id || e.siteId === id),
        id,
      );
    editing && setEditing(null);
  };
  const handleDeleteSiteClick = async () => {
    try {
      await removeAllRoles(employee?.id, row?.siteId);
    } catch (error) {
      console.log(error, "error");
    }
  };

  if (editing === id) {
    return (
      <>
        {actions.edit &&
          row.roles.map(
            (role, index) =>
              role.roleId === roleId && (
                <ButtonWrapper key={index}>
                  <Button
                    onClick={() => {
                      handleEdit(id);
                    }}
                    style={{
                      backgroundColor: "black",
                      "&:hover": { background: `${theme.color.black}` },
                    }}
                  >
                    Save
                  </Button>

                  <Button
                    onClick={() => {
                      setEditing(null);
                      fetchEmployeesSiteList(employee.id);
                    }}
                    style={{
                      background: theme.color.gray200,
                      color: "black",
                      "&:hover": { background: `${theme.color.gray200}` },
                    }}
                  >
                    Discard
                  </Button>
                </ButtonWrapper>
              ),
          )}
      </>
    );
  }
  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto",
          gap: "16px",
        }}
      >
        {/* Left column: role actions stacked vertically */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {row.roles?.map((role) => (
            <div key={role.roleId} style={{ display: "flex", gap: "8px" }}>
              <Button
                onClick={() => {
                  actions.inTableEdit ? setEditing(id) : actions.edit(id, row);
                  setRoleId(role.roleId);
                }}
                style={{
                  backgroundColor: "#FFC555",
                  padding: "6px 12px",
                  whiteSpace: "nowrap",
                  color: "white",
                }}
              >
                Edit
              </Button>

              <Button
                onClick={() => {
                  setRoleId(role.roleId);
                  inSiteDetails
                    ? actions.delete(row.employeeId, role)
                    : handleDelete(id);
                }}
                style={{
                  background: "#FF4747",
                  padding: "6px 12px",
                  whiteSpace: "nowrap",
                  color: "white",
                }}
              >
                Delete
              </Button>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {!inSiteDetails && (
            <Button
              onClick={() => setOpenDeleteAllSites(!openDeletAllSites)}
              style={{
                background: "#FF4747",
                padding: "6px 12px",
                color: "white",
                whiteSpace: "nowrap",
              }}
            >
              Delete Site
            </Button>
          )}
        </div>
      </div>

      <ModalBox
        open={open}
        operation="delete"
        handleClose={handleClose}
        handleOperation={() => {
          actions.delete(id);
          setOpen(false);
        }}
        text={`Do you want to complete the process of deleting all information?`}
      />
      <ModalBox
        open={openDeletAllSites}
        operation="delete"
        handleClose={() => {
          setOpenDeleteAllSites(!openDeletAllSites);
        }}
        handleOperation={() => {
          handleDeleteSiteClick();
          setOpenDeleteAllSites(false);
        }}
        text={`Do you want to complete the process of deleting this site?`}
      />
    </>
  );
};

export default HourlyRateActions;
